import * as React from 'react';
import { HTMLAttributes } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: block;
  text-align: right;
  padding: ${(props) => props.theme.notifications.padding.anchor};
  border-bottom: 2px solid ${(props) => props.theme.notifications.border.main};
  margin-top: -16px;

  > a {
    text-decoration: none;
  }
`;

type Props = { href?: string } & HTMLAttributes<HTMLAnchorElement>;

const MarkAllAsReadAnchor: React.FC<Props> = (props: Props) => (
  <Wrap>
    <a {...props} />
  </Wrap>
);

export { MarkAllAsReadAnchor };
